module.exports = __webpack_public_path__ + "img/d8u8esp-9a64c589-5108-421b-9978-19f1759c7ff1.9e60a9be.png";